/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Turn_AnimationInputs */

const en_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Turn Animation`)
};

const es_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animación de paso de página`)
};

const fr_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animation de page`)
};

const de_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umblätter-Animation`)
};

const ja_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページめくりアニメーション`)
};

const zh_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻页动画`)
};

const ar_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأثير تقليب الصفحة`)
};

const id_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animasi Balik Halaman`)
};

const it_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animazione Volta Pagina`)
};

const ru_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анимация перелистывания`)
};

const pt_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animação de Virar Página`)
};

const ko_page_turn_animation = /** @type {(inputs: Page_Turn_AnimationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지 넘김 애니메이션`)
};

/**
* | output |
* | --- |
* | "Page Turn Animation" |
*
* @param {Page_Turn_AnimationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const page_turn_animation = /** @type {((inputs?: Page_Turn_AnimationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Turn_AnimationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_turn_animation(inputs)
	if (locale === "es") return es_page_turn_animation(inputs)
	if (locale === "fr") return fr_page_turn_animation(inputs)
	if (locale === "de") return de_page_turn_animation(inputs)
	if (locale === "ja") return ja_page_turn_animation(inputs)
	if (locale === "zh") return zh_page_turn_animation(inputs)
	if (locale === "ar") return ar_page_turn_animation(inputs)
	if (locale === "id") return id_page_turn_animation(inputs)
	if (locale === "it") return it_page_turn_animation(inputs)
	if (locale === "ru") return ru_page_turn_animation(inputs)
	if (locale === "pt") return pt_page_turn_animation(inputs)
	return ko_page_turn_animation(inputs)
});